import {JetView} from "webix-jet"; // Importing JetView from webix-jet for creating views
import {getCities} from "models/cities"; // Importing function to get cities data
import {getTags} from "models/tags"; // Importing function to get tags data
import {getPositions} from "models/positions"; // Importing function to get positions data
import "webix/photo"; // Importing Webix photo module
import "webix/tinymce/tinymce"; // Importing TinyMCE editor from Webix
import {devConfig} from "config/config"; // Importing development configuration

/**
 * InformationView class extends JetView to create a specific view for displaying information.
 */
export default class InformationView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service for translations
        const main_info = {
          view:"scrollview", container:"toolbar", scroll:"x",  body:{
            margin: 20,
            width: (screen.width < 500) ? 500 : 0, // Responsive width based on screen size
            cols: [{
                margin: 10,
                rows: [
                    {
                        view: "text", name: "TotalDeposit", // Text input for total deposits
                        label: _("Total Depósitos"), labelPosition: "top",
                        placeholder: _("Total Depósitos"),
                        disabled: true // Input is disabled
                    },
                    {
                        view: "text", name: "TotalSportStakes", // Text input for total sports stakes
                        label: _("Total Apuestas Deportivas"), labelPosition: "top",
                        placeholder: _("Total Apuestas Deportivas"),
                        disabled: true // Input is disabled
                    },
                    {
                        view: "text", name: "TotalSportWinnings", // Text input for total sports winnings
                        label: _("Total Ganancias Deportivas"), labelPosition: "top",
                        placeholder: _("Total Ganancias Deportivas"),
                        disabled: true // Input is disabled
                    },
                    {
                        view: "text", name: "TotalCasinoStakes", // Text input for total casino stakes
                        label: _("Total Apuestas Casino"), labelPosition: "top",
                        placeholder: _("Total Apuestas Casino"),
                        disabled: true // Input is disabled
                    },
                    {
                        view: "text", name: "TotalCasinoWinnings", // Text input for total casino winnings
                        label: _("Ganancias Totales Casino"), labelPosition: "top",
                        placeholder: _("Ganancias Totales Casino"),
                        disabled: true // Input is disabled
                    },
                    {
                        view: "text", name: "TotalWithdrawal", // Text input for total withdrawals
                        label: _("Total Retiros"), labelPosition: "top",
                        placeholder: _("Total Retiros"),
                        disabled: true // Input is disabled
                    },
                    {
                        view: "text", name: "AdjustmentE", // Text input for total entry adjustments
                        label: _("Total Ajustes Entrada"), labelPosition: "top",
                        placeholder: _("Total Ajustes Entrada"),
                        disabled: true // Input is disabled
                    },
                    {
                        view: "text", name: "AdjustmentS", // Text input for total exit adjustments
                        label: _("Total Ajustes Salida"), labelPosition: "top",
                        placeholder: _("Total Ajustes Salida"),
                        disabled: true // Input is disabled
                    }
                ]
            },
            {
               margin: 20,
               width: (screen.width < 500) ? 300 : 0, // Responsive width based on screen size
               cols: [{
                   margin: 10,
                   id:"templateCol", // ID for the template column
                   rows: [
                       {
                           view: "template", // Template view for loading indicator
                           id:"templateResume", // ID for the template
                           template: "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>"
                       }
                   ]
               }
               ]
             }
            ]
          }
        };
        const upper_section = {
            id:"a1", // ID for the upper section
            rows: [
                {
                    margin: 30,
                    responsive:"a1", // Responsive behavior for the upper section
                    cols: [
                        main_info // Including main_info in the layout
                    ]
                },
            ]
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            view: "form", // Form view for the main layout
            id: "formDetails", // ID for the form
            rows: [upper_section], // Including upper_section in the form
            rules: {
                "fname": webix.rules.isNotEmpty // Validation rule for the form
            }
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance to set values on.
     */
    init(form) {
        const _ = this.app.getService("locale")._; // Localization service for translations
        this.on(this.app, "customer:updateFinance", (id) => { // Event listener for updating finance
            const test = this; // Reference to the current instance
            webix.ajax().get(devConfig.geturlApi() + "Client/GetClientKpi", 'id=' + id, {
                error: function (text, data, XmlHttpRequest) { // Error handling for AJAX request
                    webix.message("Error! "); // Display error message
                },
                success: function (text, data, XmlHttpRequest) { // Success handling for AJAX request
                    text = JSON.parse(text); // Parse the JSON response
                    var shtml ='<div style=" width: 100%; "> <h2>'+_("Resumen")+'</h2> ' + // HTML for displaying summary
                        '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">Depositos: </div><div style=" display: inline-block; font-weight: bold; color: green; float: right; ">(+)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">'+webix.i18n.priceFormat(text[0].TotalDeposit)+'</div>  </div>' +
                        '<div style=" width: 100%; border-bottom: 1px dotted; padding: 5px 0px; "> </div> ' +
                        '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">Apuestas en Deportivas: </div><div style=" display: inline-block; font-weight: bold; color: red; float: right; ">(-)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">'+webix.i18n.priceFormat(text[0].TotalSportStakes)+'</div>  </div>' +
                        '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">Apuestas en Casino: </div><div style=" display: inline-block; font-weight: bold; color: red; float: right; ">(-)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">'+webix.i18n.priceFormat(text[0].TotalCasinoStakes)+'</div>  </div>' +
                        '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">Total Apuestas: </div><div style=" display: inline-block; font-weight: bold; color: red; float: right; ">(-)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">'+webix.i18n.priceFormat((text[0].TotalCasinoStakes + text[0].TotalSportStakes ))+'</div>  </div>' +
                        '<div style=" width: 100%; border-bottom: 1px dotted; padding: 5px 0px; "> </div> ' +
                        '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">Premios en Deportivas: </div><div style=" display: inline-block; font-weight: bold; color: green; float: right; ">(+)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">'+webix.i18n.priceFormat(text[0].TotalSportWinnings)+'</div>  </div>' +
                        '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">Premios en Casino: </div><div style=" display: inline-block; font-weight: bold; color: green; float: right; ">(+)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">'+webix.i18n.priceFormat(text[0].TotalCasinoWinnings)+'</div>  </div>' +
                        '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">Total Premios: </div><div style=" display: inline-block; font-weight: bold; color: green; float: right; ">(+)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">'+webix.i18n.priceFormat((text[0].TotalSportWinnings + text[0].TotalCasinoWinnings ))+'</div>  </div>' +
                        '<div style=" width: 100%; border-bottom: 1px dotted; padding: 5px 0px; "> </div> ' +
                        '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">Notas pendientes: </div><div style=" display: inline-block; font-weight: bold; color: red; float: right; ">(-)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">'+webix.i18n.priceFormat(text[0].TotalPendingWithdrawal)+'</div>  </div>' +
                        '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">Valor Retirado: </div><div style=" display: inline-block; font-weight: bold; color: red; float: right; ">(-)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">'+webix.i18n.priceFormat(text[0].TotalWithdrawal)+'</div>  </div>' +
                        '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">Bonos: </div><div style=" display: inline-block; font-weight: bold; color: green; float: right; ">(+)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">'+webix.i18n.priceFormat(text[0].TotalBonus)+'</div>  </div>' +
                        '<div style=" width: 100%; border-bottom: 1px dotted; padding: 5px 0px; "> </div> ' +
                        '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">Ajustes Entrada: </div><div style=" display: inline-block; font-weight: bold; color: green; float: right; ">(+)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">'+webix.i18n.priceFormat(text[0].AdjustmentE)+'</div>  </div>' +
                        '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">Ajustes Salida: </div><div style=" display: inline-block; font-weight: bold; color: red; float: right; ">(-)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">'+webix.i18n.priceFormat(text[0].AdjustmentS)+'</div>  </div>' +
                        '<div style=" width: 100%; border-bottom: 1px dotted; padding: 5px 0px; "> </div> ' +
                        '<div style=" width: 100%; padding: 5px 0px;font-weight: bold;"> <div style=" display: inline-block; ">Total: </div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">'+webix.i18n.priceFormat((text[0].TotalDeposit - text[0].TotalSportStakes - text[0].TotalCasinoStakes + text[0].TotalSportWinnings + text[0].TotalCasinoWinnings - text[0].TotalPendingWithdrawal - text[0].TotalWithdrawal + text[0].TotalBonus  + text[0].AdjustmentE - text[0].AdjustmentS).toFixed(2), { decimalSize:2} )+'</div>  </div>' +
                        '</div>';
                    $$("templateResume").setHTML(shtml); // Set the HTML content of the template
                    $$("templateCol").hide(); // Hide the template column
                    $$("templateCol").show(); // Show the template column
                    test.app.callEvent("customer:updatedataFinance", [text[0]]); // Trigger event to update finance data
                }
            });
        });
        this.on(this.app, "resume:id", Id => { // Event listener for resume event
            this.app.callEvent("customer:updateFinance", [Id]); // Trigger finance update for the given ID
        });
        this.on(this.app, "customer:updatedataFinance", person => form.setValues(person)); // Event listener to set form values
    }

    /**
     * Retrieves and localizes combo options for positions, tags, and cities.
     */
    getLocalizedComboOptions() {
        const _ = this.app.getService("locale")._; // Localization service for translations
        let p_options = webix.copy(getPositions()); // Copy positions options
        p_options.map(x => x.value = _(x.value)); // Localize position values
        this.$$("position:combo").getPopup().getList().parse(p_options); // Parse positions into combo

        let t_options = webix.copy(getTags()); // Copy tags options
        t_options.map(x => x.value = _(x.value)); // Localize tag values
        this.$$("tags:combo").getPopup().getList().parse(t_options); // Parse tags into combo

        let c_options = webix.copy(getCities()); // Copy cities options
        c_options.map(x => x.value = _(x.value)); // Localize city values
        this.$$("cities:combo").getPopup().getList().parse(c_options); // Parse cities into combo
    }
}

// FILE DOCUMENTED
